import classNames from 'classnames/bind';
import { getContentMargins } from 'components/hoc/index';
import PropTypes from 'prop-types';
import React from 'react';
import { MainContent } from '../page/index';
import styles from './layout.less';

const cx = classNames.bind(styles);


const propTypes = {
  margins: PropTypes.shape({
    marginTop: PropTypes.number.isRequired,
    marginRight: PropTypes.number.isRequired,
    marginBottom: PropTypes.number.isRequired,
    marginLeft: PropTypes.number.isRequired,
  }).isRequired,
};

const SubMainLayout = ({ margins }) => (
  <div
    className={cx('content-wrapper')}
    style={margins}
    id="mainContent"
  >
    <MainContent />
  </div>
);

SubMainLayout.propTypes = propTypes;
export default getContentMargins(SubMainLayout);



// WEBPACK FOOTER //
// ./src/components/layout/subMainLayout.js